export const checkResolution = (query) => {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(";")) {
        if (document.querySelector(`.c-var .${value}-is-visible`).offsetParent != null) {
            active = true;
        }
    }
    return active;
}

export const plural = (singular, plural24, plural, count) => {
    if (count > 1 && count < 5) {
        return plural24;
    }

    return (count == 1 ? singular : plural);
};

export const checkIphone = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

export const getCssVar = (name) => {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
}

export const hasFocusVisible = () => {
    const style = document.createElement('style')
    let isSupported

    try {
        document.head.appendChild(style)
        style.sheet.insertRule(':focus-visible { color: inherit }')
        isSupported = true
    } catch {
        isSupported = false
    } finally {
        style.remove()
    }

    return isSupported
}

export const isElementInViewport = (element, wholeElementMustBeVisible = false) => {
    const rect = element.getBoundingClientRect();
    const height = window.innerHeight || document.documentElement.clientHeight;
    const width = window.innerWidth || document.documentElement.clientWidth;
    const offset = { left: 0, right: 0, top: 0, bottom: 0 };

    // All 4 corners should be in viewport
    if (wholeElementMustBeVisible) {
        return (
        rect.top >= -offset.top &&
        rect.left >= -offset.left &&
        rect.bottom <= height + offset.bottom &&
        rect.right <= width + offset.right
        );
    }

    // At least 1 corner is in viewport
    return (
        rect.right >= -offset.left &&
        rect.bottom >= -offset.top &&
        rect.left <= width + offset.right &&
        rect.top <= height + offset.bottom
    );
}
